import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import { DataTable, DATA_TABLE_CONSTANTS as CONSTANTS } from 'gnos-tables'
import _ from 'lodash'

import config from '../../../../../../../../config'

import { TABLE_ID, LOCALE_PREFIX } from './constants'
import { PRECISION } from '../../../../../../../TableCell/components/Date/constants'

import Date from '../../../../../../../TableCell/components/Date'

import hocConnect from './hocConnect'

import './style.scss'

@injectIntl
@hocConnect
export default class HistoryReport extends Component {
    static propTypes = {
        height: PropTypes.number.isRequired,
        intl: PropTypes.object.isRequired,
        locale: PropTypes.string.isRequired,
        dataTableRemoveData: PropTypes.func.isRequired,
    }

    componentWillUnmount() {
        const { dataTableRemoveData } = this.props

        dataTableRemoveData(TABLE_ID)
    }

    render() {
        const { height, locale, intl } = this.props

        // padding (40px), title (28px), table header (35px), table footer (41px) - must be greater or equal than zero
        const heightForRows = Math.max(height - 40 - 28 - 35 - 41, 0)
        // row height = 20px
        const countOfRows = _.floor(heightForRows / 20)

        return (
            <div className={'content-history-report'}>
                <div className={'title'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.history.report.title`} />
                </div>
                <DataTable
                    id={TABLE_ID}
                    uriSettings={_.merge({}, config.api.reportHistory, {
                        qs: { lang: config.languages[locale].requestKey },
                    })}
                    responsePath={'payload.response.body'}
                    columnsDefinition={[
                        {
                            Header: <FormattedMessage id={`${LOCALE_PREFIX}.history.report.rowDt`} />,
                            accessor: 'rowDt',
                            Cell: ({ value }) => <Date date={value} precision={PRECISION.SECOND} />,
                            showArrow: { direction: CONSTANTS.DATA_TABLE_ARROW.DOWN },
                        },
                        {
                            Header: <FormattedMessage id={`${LOCALE_PREFIX}.history.report.moduleName`} />,
                            accessor: 'moduleName',
                        },
                        {
                            Header: <FormattedMessage id={`${LOCALE_PREFIX}.history.report.entityName`} />,
                            accessor: 'entityName',
                        },
                    ]}
                    texts={{
                        previousText: intl.formatMessage({ id: 'global.previous' }),
                        nextText: intl.formatMessage({ id: 'global.next' }),
                        loadingText: intl.formatMessage({ id: 'global.loading' }),
                        noDataText: intl.formatMessage({ id: 'global.noData' }),
                        pageText: intl.formatMessage({ id: 'global.page' }),
                        ofText: intl.formatMessage({ id: 'global.of' }),
                        rowsText: intl.formatMessage({ id: 'global.rows' }),
                    }}
                    forceRows={countOfRows}
                    showHeaderTooltips
                />
            </div>
        )
    }
}
